import Menu from 'Models/Menu';

export default [
  Menu.recordCreate,
  Menu.directoryCreate,
  Menu.materialInformation,
  Menu.materialEdit,
  Menu.materialDelete,
  Menu.materialClone,
  Menu.materialAddNotes,
  Menu.materialHelp,
];
